module.exports = __webpack_public_path__ + "static/media/13.5e7e3514.png";